import type { BranchPermission, ModuleKey } from '../../../../shell/session/store/sessionTypes';
import type { EmployeePermission } from '../../../store/useEmployeesStore';
import { branchPermissionsToInvitationPayload } from './permissionPreview';
import type { InvitationPermissions } from '../../../application/employeeInvitations';

/** Arma payload API desde permisos de una asignación sucursal. */
export function permissionPayloadFromAssignment(
  assignment: EmployeePermission | undefined,
  visibleModules: readonly ModuleKey[]
): InvitationPermissions {
  const rows: BranchPermission[] = visibleModules.map((module) => {
    const existing = assignment?.permissions.find((p) => p.module === module);
    if (existing) return existing;
    return {
      module,
      canView: false,
      canEdit: false,
      canVoid: false,
      canDiscount: false,
      canViewOthers: true,
      actions: {},
    };
  });
  return branchPermissionsToInvitationPayload(rows);
}
